import React from 'react';
import PlatformImg from '@gp/components/PlatformIcon/PlatformImg';
import ProjectItem from '@gp/components/ProjectItem';
import PureSelect from '@gp/components/PureSelect';
import { toProjectDetails } from '@gp/utils/project';
import { DPS_REPORT_FORM_CONTROL_PLACEHOLDER } from '../constants';

import type { TableColumn } from 'tea-component';
import type { IDPSReportProjectSimpleDTO } from '@gp/types/dpsReport/common';

const PROJECT_ID_KEY = 'project_id';

const toDetailsMilestone = (cvm: IDPSReportProjectSimpleDTO, ...restParams: [React.SyntheticEvent | null, boolean]) => {
  const { project_id: projectId, project } = cvm || {};
  const params = {
    id: projectId as any,
    name: project,
    tab: 'milestone',
  };
  return toProjectDetails(params, ...restParams);
};

export const buildProjectColumn = <T extends IDPSReportProjectSimpleDTO>(
  props?: Omit<TableColumn<T>, 'key' | 'header'> & {
    key?: TableColumn['key'];
    header?: TableColumn['header'];
    width?: TableColumn['width'];
    toDetails?: (data: T, e: React.MouseEvent<Element, MouseEvent> | null, isJump: boolean) => string;
  },
): TableColumn<T> => {
  const {
    key = PROJECT_ID_KEY,
    align = 'left',
    header = 'Project',
    width = 240,
    toDetails = toDetailsMilestone,
    ...restProps
  } = props || {};

  return {
    ...restProps,
    key,
    align,
    header,
    width,
    render: (cvm) => {
      const { project, cover, platform } = cvm || {};
      const platformStr = platform?.join('|') || '';
      return (
        <ProjectItem
          isShowAllContent
          platformTranformSolt
          generalImageProps={{ crossOrigin: 'anonymous' }}
          src={cover || ''}
          title={project || '-'}
          platform={platformStr}
          data={cvm}
          toDetails={toDetails}
          solt={<PlatformImg platform={platformStr} />}
        />
      );
    },
  };
};

export const buildProjectSelectColumn = <T extends IDPSReportProjectSimpleDTO>(
  props: Omit<TableColumn<T>, 'key' | 'header'> & {
    placeholder?: string;
    key?: TableColumn['key'];
    header?: TableColumn['header'];
    width?: TableColumn['width'];
    showTextWhenSelected?: boolean;
    options?: IGPSelectOptionWithGroup[];
    onChange?: (payload: string, cvm: T) => void;
  },
): TableColumn<T> => {
  const {
    placeholder = '-',
    key = PROJECT_ID_KEY,
    align = 'left',
    header = 'Project',
    width,
    showTextWhenSelected = true,
    options,
    onChange,
  } = props || {};

  return {
    key,
    align,
    header,
    width,
    render: (cvm) => {
      const { project_id: projectId, project } = cvm || {};
      if (showTextWhenSelected && projectId && project) return <span>{project || placeholder}</span>;
      return (
        <PureSelect
          placeholder={DPS_REPORT_FORM_CONTROL_PLACEHOLDER}
          button={project}
          options={options}
          value={projectId}
          onChange={(payload) => {
            onChange?.(payload, cvm);
          }}
        />
      );
    },
  };
};
